<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {getLoggedUser} from '@/services/AuthService';
import ClientService from "@/services/ClientService";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {showSuccessMessage} from "@/helper";
import router from "@/router";
import {useDataTable} from "@/utils/datatableHelper";
import FormTemplateService from "@/services/FormTemplateService";
import CreateUpdateFormsTemplatesModal from "@/components/modals/CreateUpdateFormsTemplatesModal.vue";

import {useI18n} from 'vue-i18n'

const {t} = useI18n();

// nastavení tabulky (stránka, počet řádků, řazení, filtry) se pamatuje v localStorage pod klíčem FORMS-TEMPLATES-INDEX
const datatableRef = ref(null);
const datatable = useDataTable(fetchFormsTemplates, 'name', 20, true, {}, 'FORMS-TEMPLATES-INDEX', datatableRef);

const formsTemplatesTypes = ref([{value: 'FORM', label: t('formsTemplates.type_FORM')}, {value: 'AML_QUESTIONNAIRE', label: t('formsTemplates.type_AML_QUESTIONNAIRE')}, {value: 'INVESTMENT_QUESTIONNAIRE', label: t('formsTemplates.type_INVESTMENT_QUESTIONNAIRE')}, {value: 'MEETING_RECORD', label: t('formsTemplates.type_MEETING_RECORD')}]);

const columns = ref([
  {
    label: t('formsTemplates.name'),
    field: 'name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('formsTemplates.version'),
    field: 'version',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label:  t('formsTemplates.type'),
    field: 'type',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    },
    formatFn: (value) => {
      return formsTemplatesTypes.value.find(type => type.value === value)?.label;
    }
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(() => {
  fetchFormsTemplates(datatable.body);
});

function fetchFormsTemplates(body) {
  FormTemplateService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    datatable.rows.value = response.data;
    datatable.isLoading.value = false;
  });
}

function createFormsTemplate(formsTemplate = null) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateFormsTemplatesModal, {formsTemplate: formsTemplate});
  reveal();
  onConfirm((data) => {
    FormTemplateService.saveFormsTemplate(data).then(response => {
      showSuccessMessage(response.message);
      fetchFormsTemplates(datatable.body);
    });
  });
  onCancel(() => {
  });
}

function deleteFormsTemplate(id) {
  FormTemplateService.deleteFormsTemplate(id).then(response => {
    showSuccessMessage(response.message);
    fetchFormsTemplates(datatable.body);
  });
}

function navigateTo(to) {
  router.push(to);
}

</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{  t('general.back') }}</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('formsTemplates.forms_templates') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <Button :label="t('formsTemplates.add_template')" icon="mdi-text-box-plus" @click="createFormsTemplate()"></Button>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <vue-good-table
          ref="datatableRef"
          :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
          :columns="columns"
          :rows="datatable.rows.value"
          mode="remote"
          @page-change="datatable.onPageChange"
          @sort-change="datatable.onSortChange"
          @column-filter="datatable.onColumnFilter"
          @per-page-change="datatable.onPerPageChange"
          :totalRows="datatable.totalRecords.value"
          :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('formsTemplates.entriesPerPage'),
                  nextLabel: t('formsTemplates.next'),
                  prevLabel: t('formsTemplates.previous'),
                  ofLabel: 'z',
                }">
        <template #table-row="props">
                                      <span v-if="props.column.field == 'action'">
                                          <span style="font-weight: bold; float: right">
                                              <button type="button" class="btn btn-link" @click="createFormsTemplate(props.row)"><i class="mdi mdi-pencil"/></button>
                                              <button type="button" class="btn btn-link" @click="deleteFormsTemplate(props.row.id)"><i class="mdi mdi-delete"/></button>
                                          </span>
                                      </span>
        </template>
        <template v-slot:emptystate v-if="!datatable.isLoading.value">
          <div class="text-center">
          {{ t('formsTemplates.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="datatable.isLoading.value">
          <div class="text-center">
          {{ t('formsTemplates.data_loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
